import './assets/css/App.css';
import Header from "./components/Header";
import CreateOrder from "./pages/CreateOrder";
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom'
import useLang from "./Lang/useLang";
import Strings from "./Lang/strings";
import CompletedOrder from "./pages/ComletedOrder";
import React from "react";
import talabateyLogo from "./assets/images/small-logo.png";
import zainLogo from "./assets/images/zain-logo.png";

function App() {
    const {lang, setLang, rtlLangs, toggleDirection} = useLang();
    Strings.setLanguage(lang)
    toggleDirection(rtlLangs.includes(lang) ? "rtl" : "ltr");

    return (
        <Router>
            <Header setLang={setLang}/>
            <main className="flex min-h-screen">
                <Switch>
                    <Route exact={true} path="/">
                        <BlankScreen/>
                    </Route>
                    <Route path="/order/:uuid">
                        <CreateOrder/>
                    </Route>
                    <Route path="/completed">
                        <CompletedOrder/>
                    </Route>
                    <Route path="*">
                        <Redirect to={"/"}/>
                    </Route>
                </Switch>
            </main>
            <Footer/>
            <Loader/>
        </Router>
    );
}

function BlankScreen() {
    return <div id="blank"
                className="fixed top-0 left-0 right-0  bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-200"/>

}


function Loader() {
    return <div id="global-loader"
                className="hidden fixed top-0 left-0 right-0 bottom-0 w-full h-screen overflow-hidden bg-black opacity-90 flex flex-col items-center justify-center">
        <div className="loader ease-linear rounded-full border-4 border-t-4  h-16 w-16 mb-4"></div>
        <h2 id={"global-loader-title"}
            className="text-center text-white text-2xl font-semibold">{Strings.loadingRaised}...</h2>
        {/*<p className="lg:w-1/3 w-full text-center text-white">This may take a few seconds, please don't close this*/}
        {/*    page.</p>*/}
    </div>

}

function Footer() {

    return <footer className={"p-1 bg-white relative w-full flex justify-around items-center  opacity-75 mt-2"}
                   style={{direction: "initial"}}>
        <h2 className={"capitalize flex-1 sm:text-sm text-xs  min-w-max inline-block mx-auto   text-center"}>&copy; zain
            sim
            swap, powered by talabatey</h2>
        <div className={" flex justify-end items-center sm:mx-1"}>
            <a href="https://talabatey.com/" style={{"objectFit": "contain", "width": "77px"}}
               className={"w-10 right-1.5  inline h-10"}>
                <img src={talabateyLogo}
                     alt="talabatey  logo"/>
            </a>
            <a href="https://zain.com/" className={"p-1 sm:mx-1 left-1.5 bg-gray-100  inline"}
               style={{"objectFit": "contain", "width": "77px"}}>
                <img src={zainLogo}
                     alt="zain logo"/>
            </a>
        </div>

    </footer>
}


export default App;
